import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  hideExtraData,
  saveData,
  updateAll,
  updateMaxMonthlyOrders,
  updateName, updatePassword,
  updatePhone, updateSaving, updateWeakPassPopover
} from './state/complete_actions_creator';
import { CompleteState, cloneState } from './state/complete_state';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { DropDownOption } from '../../shared/models/dropdown_option';
import { WindowService } from '../../shared/services/window.service';
import {
  MAX_DISPLAY_NAME_LENGTH, MIN_PASSWORD_LENGTH, MAX_PASSWORD_LENGTH,
  STRONG_PASSWORD_PATTERN, MIN_WEAK_PASSWORD_LENGTH, WEAK_PASSWORD_PATTERN
} from '../shared/constants';
import { REDCRSS_EVENTS } from '../../shared/services/constants/redcross_evemts';
import { monthlyOrderOptions } from '../shared/constants';
import { PlatformService } from '../../shared/services/platforms/platform.service';
import { FlowTrackingService } from '../shared/services/flow-tracking.service';
import { IAppState } from '../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({
  selector: 'yi-complete',
  template: require('./complete.component.html'),
  styles: [require('./complete.component.scss')]
})
export class CompleteComponent implements OnInit {

  popoverPlacement = this.windowService.isNarrowWindow() ? 'top' : 'right';
  nameMaxLength = MAX_DISPLAY_NAME_LENGTH;
  passwordMinLength = MIN_PASSWORD_LENGTH;
  passwordMaxLength = MAX_PASSWORD_LENGTH;
  passwordPattern = STRONG_PASSWORD_PATTERN;
  strongPasswordNeeded = true;
  submitted = false;
  saving = false;
  validName = false;
  isMaxNameLength = false;
  isMinNameLength = true;
  validPassword = false;
  @ViewChild('invalidNamePop') invalidNamePop: PopoverDirective;
  @ViewChild('invalidPasswordPop') invalidPasswordPop: PopoverDirective;
  public monthlyOrderOptions = monthlyOrderOptions;
  private state: CompleteState;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<IAppState>,
    private redCrossService: AnalyticsTrackingProvider,
    private windowService: WindowService,
    private platformService: PlatformService,
    private flowTrackingService: FlowTrackingService
  ) {
    this.store.select(state => state.app.signup.complete).subscribe((data: CompleteState) => {
      this.state = cloneState(data);
      this.saving = data.saving;
      if (data.weakPassPopover) {
        this.showWeakPasswordPopover();
      }
    });
  }


  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      let completeParams = {
        originalParams: {}
      };
      Object.keys(params).forEach(function (key) {
        completeParams['originalParams'][key] = decodeURI(params[key]);
      });

      if (this.shouldHideExtraData(params)) {
        this.store.dispatch(hideExtraData({hideExtraData: true}));
      }

      let displayName = completeParams['originalParams']['display_name'];
      if (displayName) {
        completeParams['displayName'] = displayName;
        this.validName = this.isValidName(displayName);
      }

      let platformId = completeParams['originalParams']['platform_id'];
      if (platformId) {
        this.strongPasswordNeeded = this.platformService.shouldUseStrongPassword(Number(platformId));
        if (!this.strongPasswordNeeded) {
          this.passwordMinLength = MIN_WEAK_PASSWORD_LENGTH;
          this.passwordPattern = WEAK_PASSWORD_PATTERN;
        }
      }

      this.store.dispatch(updateAll({payload: completeParams}));
      let analyticaParams = { pageCategory: 'Registration' };
      Object.assign(analyticaParams, completeParams['originalParams']);
      this.redCrossService.page(REDCRSS_EVENTS.VIEWED_B2B_PAGE, analyticaParams);
    });
    this.flowTrackingService.StepAppStarted(this.activatedRoute.snapshot);
  }

  onSubmit(form) {
    this.submitted = true;
    let isValidName = this.validateDisplayName();
    let isValidPassword = this.validatePassword();

    if (form.valid && isValidName && isValidPassword) {
      this.flowTrackingService.StepAppInProgress();
      this.store.dispatch(updateSaving({saving: true}));
      this.store.dispatch(saveData());
    } else {
      if (!isValidName) {
        this.invalidNamePop.show();
      }
      if (!isValidPassword) {
        this.invalidPasswordPop.show();
      }
    }
  }

  nameChanged(displayName) {
    this.validateDisplayName();
    this.store.dispatch(updateName({displayName}));
  }

  passwordChanged(newPassword) {
    this.validatePassword();
    this.store.dispatch(updatePassword({newPassword}));
  }

  monthlyOrdersChanged(option: DropDownOption<string>) {
    this.store.dispatch(updateMaxMonthlyOrders({maxMonthlyOrders: option.value}));
  }

  phoneChanged(phone) {
    this.store.dispatch(updatePhone({phone}));
  }

  hidePopovers() {
    if (this.invalidNamePop && this.invalidPasswordPop) {
      this.invalidNamePop.hide();
      this.invalidPasswordPop.hide();
    }
    this.store.dispatch(updateWeakPassPopover({weakPassPopover: false}));
  }

  private validateDisplayName(): boolean {
    this.validName = this.isValidName(this.state.displayName);
    return this.validName;
  }

  private validatePassword(): boolean {
    this.validPassword = this.isValidPassword(this.state.newPassword);
    return this.validPassword;
  }

  private isValidName(displayName): boolean {
    this.isMaxNameLength = displayName.length >= this.nameMaxLength;
    this.isMinNameLength = displayName.length === 0;
    return !this.isMaxNameLength && !this.isMinNameLength;
  }

  private isValidPassword(password): boolean {
    let passwordRegex = new RegExp(`^${this.passwordPattern}$`);
    return password.length >= this.passwordMinLength
      && password.length <= this.passwordMaxLength
      && password.match(passwordRegex);
  }

  private showWeakPasswordPopover() {
    if (this.invalidPasswordPop) {
      this.invalidPasswordPop.show();
    }
  }

  private shouldHideExtraData(urlParams): boolean {
    return urlParams['product'] && urlParams['product'].toLowerCase() === 'sms';
  }
}
